import {
  GET_MEMBERSHIP,
  GET_MEMBERSHIP_BY_ID,
  GET_MY_MEMBERSHIP_DETAILS,
} from "../constants";

export const membership = (
  state = { membershiplist: [], membershipbyid: {}, mymebershipdetails: {} },
  action,
) => {
  switch (action.type) {
    case GET_MEMBERSHIP:
      return { ...state, membershiplist: action.membershiplist };
    case GET_MEMBERSHIP_BY_ID:
      return { ...state, membershipbyid: action.membershipbyid };
    case GET_MY_MEMBERSHIP_DETAILS:
      return { ...state, mymebershipdetails: action.mymebershipdetails };
    default:
      return state;
  }
};
